<section *ngIf="!(bookingSuccessfullyDone$ | async) || !isLoggedInUser" class="background-color-nearwhite">
    <div class="container" *ngIf="order$ | async as order">
        <h3 [innerHTML]="'booking.bookingSummary.title' | translate"></h3>
        <da-checkout-list [isBookingSummary]="true" (emitTotalPrice)="getTotalPrice($event)"></da-checkout-list>
        <div class="top-cards">
            <div *ngIf="order.user" class="person">
                <h4 [innerHTML]="'booking.bookingSummary.subtitlePerson' | translate"></h4>
                <da-person-card [person]="order.user" (nextStep)="goToStep($event)"></da-person-card>
            </div>
            <ng-container>
                <div *ngIf="order.billing" class="person">
                    <h4 [innerHTML]="'booking.bookingSummary.subtitleBilling' | translate"></h4>
                    <da-person-card [person]="order.billing" (nextStep)="goToStep($event)" [isBillingContact]="true"></da-person-card>
                </div>
            </ng-container>
        </div>

        <div *ngIf="order.participants">
            <h4 [innerHTML]="'booking.bookingSummary.subtitleParticipants' | translate"></h4>
            <div class="participants" *ngIf="!order.isGroupBooking">
                <div class="person" *ngFor="let item of order.participants; let i = index" id="card{{ i }}" [@flyInOut]>
                    <ng-container class="card">
                        <a class="delete disabled" *ngIf="order.participants.length === 1" (click)="showWarning()"
                            ><span class="drg-icon-delete"></span
                            ><span class="text" [innerHTML]="'booking.bookingSummary.remove' | translate"></span
                        ></a>
                        <a class="delete" *ngIf="order.participants.length !== 1" (click)="removeParticipant(i)"
                            ><span class="drg-icon-delete"></span
                            ><span class="text" [innerHTML]="'booking.bookingSummary.remove' | translate"></span
                        ></a>
                        <da-person-card
                            [person]="item.person"
                            [orderNumber]="i + 1"
                            (nextStep)="goToStep($event)"
                            [isParticipant]="true"
                        ></da-person-card>
                    </ng-container>
                </div>
            </div>
            <div *ngIf="order.isGroupBooking">
                <div class="group-booking-wrapper">
                    <h5 [innerHTML]="'booking.bookingSummary.groupBookingTitle' | translate"></h5>
                    <da-participants-list [isBookingSummary]="true" [participants]="order.participants"></da-participants-list>
                </div>
            </div>
        </div>
        <div class="data-group full-width">
            <div class="group">
                <label class="checkboxlabel">
                    <input type="checkbox" id="subscribe" (change)="checked()" />
                    <label for="subscribe" class="subscribe-me" [innerHTML]="'booking.bookingSummary.agree' | translate"></label>
                </label>
            </div>
        </div>
        <div class="error">
            <div *ngIf="showErrorRequired" [innerHTML]="'booking.bookingSummary.required' | translate"></div>
        </div>

        <div class="button-wrapper">
            <a da-link class="button secondary" (click)="goToStep(2)" [innerHTML]="'booking.booking.back' | translate"></a>
            <!-- <a *ngIf="!onlyWebinars || !isLoggedInUser || (site !== 'de_ch' && site !== 'fr_ch' && portalID !== 'ch-ext-sd' && portalID !== 'ch-ext-md')" da-link class="button primary" (click)="goToStep(4)" [innerHTML]="'booking.booking.requestTheBooking' | translate"></a> -->
            <!-- <a *ngIf="onlyWebinars && isLoggedInUser && (site === 'de_ch' || site === 'fr_ch' || portalID === 'ch-ext-sd' || portalID === 'ch-ext-md')" da-link class="button primary" (click)="goToStep(4)" [innerHTML]="'booking.booking.toPayment' | translate"></a> -->
            <a da-link class="button primary" (click)="goToStep(4)" [innerHTML]="'booking.booking.requestTheBooking' | translate"></a>
        </div>
        <div  class="error server">
            <div *ngIf="showErrorMessage$ | async" [innerHTML]="'booking.bookingSummary.error' | translate"></div>
        </div>
    </div>
</section>
<!-- <section *ngIf="(bookingSuccessfullyDone$ | async) && isLoggedInUser"  class="background-color-nearwhite">
    <div class="container">
        <h3 [innerHTML]="'booking.booking.payment' | translate"></h3>
    </div>
</section> -->

<ng-template #overlay>
    <div class="embedcontainer">
        <ng-container *ngTemplateOutlet="warning"></ng-container>
    </div>
</ng-template>
<ng-template #warning>
    <div class="warning-popup">
        <div class="inner-wrapper">
            <div class="details">
                <h3 [innerHTML]="'booking.bookingSummary.deleteParticipantTitle' | translate"></h3>
                <p [innerHTML]="'booking.bookingSummary.deleteParticipantText' | translate"></p>
                <div class="button-wrapper">
                    <a
                        (click)="cancleOrder()"
                        class="button secondary"
                        [innerHTML]="'booking.bookingSummary.deleteParticipantBtn' | translate"
                    ></a>
                    <a
                        (click)="goToEditParticipants()"
                        class="button primary"
                        [innerHTML]="'booking.bookingSummary.cancleDeleteParticipant' | translate"
                    ></a>
                </div>
            </div>
        </div>
    </div>
</ng-template>
<!-- <da-booking-payment *ngIf="isLoggedInUser && onlyWebinars && (site === 'de_ch' || site === 'fr_ch' || portalID === 'ch-ext-sd' || portalID === 'ch-ext-md')" [order]="order$ | async" [totalPrice]="totalPrice" [countryCode]="countryCode" [bookingSuccessfullyDone]="bookingSuccessfullyDone$ | async"></da-booking-payment> -->
